import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Highchart from 'components/organisms/Chart/Highchart';
import ContentsWrap from 'components/molecules/ContentsWrap';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  barGraphBox: {
    width: '100%',
    boxSizing: 'border-box',
  },
}));

const BrowserBarGraph = (props) => {
  const { t } = useTranslation();
  const { barData, loading } = props;

  const classes = useStyles();

  //하이차트 기본설정
  const initOptions = {
    chart: {
      height: 230,
      type: 'bar',
    },
    colors: [
      '#8D4653',
      '#8085E8',
      '#E4D354',
      '#F15C80',
      '#268b1f',
      '#F7A35C',
      '#90ED7D',
      '#e0e0e0',
      '#7CB5EC',
    ],
    yAxis: {
      min: 0,
      title: {
        enabled: false,
      },
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineColor: 'transparent',
      labels: {
        enabled: false,
      },
      minorTickLength: 0,
      tickLength: 0,
    },
    plotOptions: {
      pointPadding: 0.2,
      borderWidth: 0,
      series: {
        stacking: 'normal',
      },
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        let tooltipMarkup =
          '<b>' +
          this.series.name +
          '</b><br />' +
          this.percentage.toFixed(2) +
          '%';

        return tooltipMarkup;
      },
      useHTML: true,
      style: {
        zIndex: 10001,
      },
    },
    series: [],
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'top',
      reversed: true,
    },
    credits: {
      enabled: false, //하단 로고 삭제
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      lineColor: 'transparent',
      labels: {
        enabled: false,
      },
      minorTickLength: 0,
      tickLength: 0,
    },
  };

  const [graphList, setGraphList] = useState([]);

  useEffect(() => {
    if (barData !== undefined) {
      let graphKeyArray = barData.bar;
      let newGraphList = [];
      let tmpSeries = [];
      graphKeyArray.forEach((row) => {
        tmpSeries = [];
        row.data.forEach((item) => {
          tmpSeries.push({
            name: item.name,
            data: [parseInt(item.val)],
          });
        });
        newGraphList.push({
          ...initOptions,
          title: {
            text: t(`${row.title} 점유율`),
          },
          series: tmpSeries.reverse(),
        });
      });
      setGraphList(newGraphList);
    } // eslint-disable-next-line
  }, [barData]);

  /**
   * 그래프용 데이터 가공
   */
  const makeGraphData = useCallback(
    (graphList) => {
      const result = [];
      for (let i in graphList) {
        result.push(
          <div key={i} className={classes.barGraphBox}>
            <Highchart options={graphList[i]} />
          </div>
        );
      }
      return result;
    }, // eslint-disable-next-line
    []
  );
  return (
    <>
      <ContentsWrap contentsCount={1} loading={loading}>
        {makeGraphData(graphList)}
      </ContentsWrap>
    </>
  );
};

const equalComparison = (prevProps, nextProps) => {
  if (JSON.stringify(prevProps.params) !== JSON.stringify(nextProps.params)) {
    return false;
  }
};

BrowserBarGraph.propTypes = {
  params: PropTypes.object.isRequired,
};
export default React.memo(BrowserBarGraph, equalComparison);
